import SponsorListPage from "@/views/sponsor/SponsorListPage.vue";
import SponsorDtlPage from "@/views/sponsor/SponsorDtlPage.vue";
import SponsorDonateListPage from "@/views/sponsor/SponsorDonateListPage.vue";

const sponsorRoutes = [
  {
    path: "/sponsor",
    children: [
      {
        path: "",
        name: "SponsorListPage",
        component: SponsorListPage,
      },
      {
        path: "sponsor-dtl/:sponsorSeq",
        name: "SponsorDtlPage",
        components: {
          default: SponsorDtlPage,
        },
        props: {
          default: true,
        },
      },
      {
        path: "sponsor-donate-list",
        name: "SponsorDonateListPage",
        component: SponsorDonateListPage,
      },
    ],
  },
];

export default sponsorRoutes;
